export interface Task {
    id: number;
    title: string;
    description: string;
    path: string;
    identifier: IDENTIFIERS;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    completed: boolean;
    type: string;
    sequence: number;
}

export interface UpdateTaskSchema {
    type: IDENTIFIERS;
    completed: boolean;
}

export const taskTypes = { firstLogin: 'firstlogin', signUp: 'signup', error: 'error' };
export const CONNECT_BANK_ACCOUNT_IDENTIFIER = 'CONNECT_BANK_ACCOUNT';
export const UPLOAD_PROGRAM_CREATOR_LIST_IDENTIFIER = 'UPLOAD_PROGRAM_CREATOR_LIST';
export const SETUP_HUB_IDENTIFIER = 'SETUP_HUB';
export const CONNECT_SHOP_IDENTIFIER = 'CONNECT_SHOP';
export const CONNECT_EMAIL_IDENTIFIER = 'CONNECT_EMAIL';
export const ACTIVATE_SEQUENCE_IDENTIFIER = 'ACTIVATE_SEQUENCE';
export const FIRST_WELCOME_IDENTIFIER = 'FIRST_WELCOME';
export const FIRST_CONTACTS_IDENTIFIER = 'FIRST_CONTACTS';
export const EMAIL_CONNECTION_NOTIFICATION_IDENTIFIER = 'EMAIL_CONNECTION_NOTI';
export const FIRST_RECRUIT_IDENTIFIER = 'FIRST_RECRUIT';
export const SET_SIGN_UP_FLOW_MODAL = 'SET_SIGN_UP_FLOW_MODAL';
export const SET_SIGN_UP_FLOW_TASKS = 'SET_SIGN_UP_FLOW_TASKS';
export const SOCIAL_TRACKING_IDENTIFIER = 'SOCIAL_TRACKING';
export type IDENTIFIERS =
    | typeof SETUP_HUB_IDENTIFIER
    | typeof CONNECT_EMAIL_IDENTIFIER
    | typeof ACTIVATE_SEQUENCE_IDENTIFIER
    | typeof FIRST_WELCOME_IDENTIFIER
    | typeof FIRST_CONTACTS_IDENTIFIER
    | typeof EMAIL_CONNECTION_NOTIFICATION_IDENTIFIER
    | typeof FIRST_RECRUIT_IDENTIFIER
    | typeof CONNECT_BANK_ACCOUNT_IDENTIFIER
    | typeof UPLOAD_PROGRAM_CREATOR_LIST_IDENTIFIER
    | typeof SOCIAL_TRACKING_IDENTIFIER
    | typeof CONNECT_SHOP_IDENTIFIER;

export const UPDATE_TASK = 'UPDATE_TASK';

interface SetSignUpFlowTaskAction {
    type: typeof SET_SIGN_UP_FLOW_TASKS;
    payload: Task[];
}
interface UpdateTaskAction {
    type: typeof UPDATE_TASK;
    payload: UpdateTaskSchema;
}

interface OpenSignUpFlowModalAction {
    type: typeof SET_SIGN_UP_FLOW_MODAL;
    payload: boolean;
}

export type SignUpFlowActionTypes =
    | UpdateTaskAction
    | OpenSignUpFlowModalAction
    | SetSignUpFlowTaskAction;

export interface SignUpFlowState {
    tasks: Task[];
    openModal: boolean;
}
